// NOTE: This can be extended/improved to calculate the number of rows
// based on the viewport height and the row height using a ResizeObserver.
// For now, we are not going that far.

export default function rowsToFill(
  viewportHeight,
  rowHeight = 56,
  compensation = 152, // 152px is the height of the header and heading area
  minRows = 10,
) {
  const availableHeight = viewportHeight - compensation;
  const rows = Math.floor(availableHeight / rowHeight);
  return Math.max(rows, minRows);
}
